<app-sidebar>
  <div class="street-search-page">
    <div class="page-header">
      <h1>Street Search</h1>
      <p>Click any street line to view available houses and ERFs.</p>
    </div>

    <mat-card class="map-card">
      <mat-card-content>
        <div *ngIf="isLoading" class="loading-state">
          <mat-spinner diameter="42"></mat-spinner>
          <p>{{ loadingMessage }}</p>
        </div>

        <div *ngIf="!isLoading" class="map-summary">
          <span><strong>{{ streetCount }}</strong> streets</span>
          <span><strong>{{ lineSegmentCount }}</strong> line segments</span>
          <span *ngIf="selectedStreetLabel">Selected: <strong>{{ selectedStreetLabel }}</strong></span>
        </div>

        <div #mapContainer class="map-container" [class.hidden]="isLoading"></div>
      </mat-card-content>
    </mat-card>
  </div>
</app-sidebar>
